export const isActive = (pathname: string, path: string): boolean =>
  pathname.includes(path);

export const isActiveExact = (pathname: string, path: string): boolean =>
  pathname === path;

export const getNavlinkColor = (active: boolean): 'primary' | 'secondary' =>
  active ? 'primary' : 'secondary';
